'use strict'

import React from 'react';
import request from 'superagent';

import Layout from './Layout.jsx';

import Area from './components/Area2.jsx';
import Field from './components/Field3.jsx';
import AreaForm from './components/AreaForm.jsx';

import Translations from '../app/utils/translations.js';
let translations=new Translations([
    require('./extremeProject/labels/english.js'),
    require('./extremeProject/labels/norwegian.js')
]);

import formDefinition from './extremeProject/formDefinition.js';

class GeneralInformation extends React.Component {
  render() {
    var questions=[
      "Tell me about the project you have in mind."
    ];
    return (
      <Area title="General Information">
        <Field title="Project Name" name="name" description="A descriptive name of the project"
          help={questions.join("\n")}/>
      </Area>
    );
  }
}

class BusinessObjective extends React.Component {
  render() {
    var questions=[
      "What opportunity are we going after?",
      "What’s the business need that this project is intended to address?",
      "What is it that we are fixing, trying to improve, or solve?",
      "How will the project enable your organization to serve its customers better?"
    ];

    return (
      <Area title="Business Objective">
        <Field name="background" title="Business Objective"
          height="2" help={questions.join("\n")} description="The reason to run the project"/>
      </Area>
    );
  }
}

class DeliverableQualityAndScope extends React.Component {
  render() {
    var description="These questions dvelve into the product or service that is to be produced: “If we had it in place right now [the process, system, the product, the new service …”";
    var questions=[
      "What would you see as its main functions or features?",
      "Is this intended to be a stop-gap measure: We’ll do it once, and if we replace it, will we start all over from scratch? Or are we trying to do something that we will attempt to fix and upgrade over time?",
      "What would be the absolute bare minimum functions?",
      "What would it physically look like?"
    ];

    return (
      <Area title="Deliverables">
        <Field name="benefitsDescription" title="Project Deliverable Quality and Scope"
          height="2" help={description+"\n\n"+questions.join("\n")}  description="The qualities of deliverables and project scope"/>
      </Area>
    );
  }
}

class BusinessOutcome extends React.Component {
  render() {
    var description="These questions are aimed at identifying the value-added dollar-and-cents benefits that are being sought as a result of having produced the project deliverable. “Assuming we had completed the project and it was now up and running…”:";
    var questions=[
      "What s the most important payoff you are looking to achieve? Increased revenue? Better customer service? Greater marked share? Decreased cost of doing business? Short-term profits?",
      "How would you quantify the dolar payoff you are targeting? ROI? Reduced cost? Over what period of time?",
      "What will you want to see to know that the business benefits have been achieved?",
      "Under what conditions would we shut down the project?"
    ];
    return (
      <Area title="Business Outcome">
        <Field name="outcomes" title="Business Outcome"
          height="2" help={description+"\n\n"+questions.join("\n")} description="The expected result of the project"/>
      </Area>
    );
  }
}

class Context extends React.Component {
  render() {
    var description="These questions elict information about the business climate surrounding the project:";
    var questions=[
      "How does this project fit in with the origanization’s overall business strategy?",
      "Who’s driving this project from above?",
      "Who will you be going to for approvals and funding?",
      "What’s driving us to this now? What is we did nothing? Waited until next year?",
      "How does this fit into the overall priority of projects?",
      "If we have to let another project slip, what might that be?"
    ];
    return (
      <Area title="Context">
        <Field name="bigPicture" title="Context"
          height="2" help={description+"\n\n"+questions.join("\n")} description="In which context does the project exist"/>
      </Area>
    );
  }
}

class Stakeholders extends React.Component {
  render() {
    var description="These questions relate to the politics of the project. Here you want to find out whom this project is intended to affect, for better or for worse. Thiose affected can be wither internal or external to your organization.";
    var questions=[
      "For whose benefit is the project being undertaken?",
      "What customer group or department is the project intended to affect?",
      "Who is likely to feel threathened by this project or have strong opinions?",
      "Who do we need to talk to that has to be happy with the resoults?",
      "Who are the strong supporters of this project?"
    ];
    return (
      <Area title="Stakeholders">
        <Field name="stakeholderDescription" title="Stakeholders"
          height="2" help={description+"\n\n"+questions.join("\n")} description="Who are affected by the project"/>
      </Area>
    );
  }
}

class Timing extends React.Component {
  render() {
    var questions=[
      "What’s the time frame or deadline you have in mind?",
      "What’s driving the deadline?",
      "What latitude is there?"
    ];
    return (
      <Area title="Timing">
        <Field name="timing" title="Timing"
          height="2" help={questions.join("\n")} description="In which time period will the project be performed"/>
      </Area>
    );
  }
}

class ResourcesAndBudget extends React.Component {
  render() {
    var questions=[
      "What would you expect to spend on this project?",
      "Whose budget is this coming out of?",
      "Who will I talk to when I need staff for the project?"
    ];
    return (
      <Area title="Resources and Budget">
        <Field name="constraints" title="Resources and Budget"
          height="2" help={questions.join("\n")} description="What is required to run the project"/>
      </Area>
    );
  }
}

class TradeOffs extends React.Component {
  render() {
    var description="When trade-offs have to be made, which one of the drivers for this project must be achived (that is, it cannot be sacrificed)?";
    var questions=[
      "ROI, time line, budge, functions and features, quality, customer / stakeholder satisfaction, team satisfaction?",
      "What is the second most important driver?"
    ];
    return (
      <Area title="Trade offs">
        <Field name="objectives" title="Trade-Offs"
          height="2" help={questions.join("\n")} description="What are the priorities"/>
      </Area>
    );
  }
}

class WorkingRelationship extends React.Component {
  render() {
    var questions=[
      "How do you see your role with respect to decision making? Funding? Staffing? Who else wil you look to for this?",
      "How do you see my role on the project?",
      "What progress reporting information will be important to you?"
    ];
    return (
      <Area title="Working Relationship">
        <Field name="assumptions" title="Working Relationship"
          height="2" help={questions.join("\n")} description="What are the expectations to you as responsible for the project"/>
      </Area>
    );
  }
}


export class NewExtremeProject extends React.Component {
  submitProject(form) {
    /*
      translation to PRINCE2 definition:
      Business Objective (objective) -> background
      Project Deliverable Quality and Scope (deliverable) -> benefitsDescription
      Business Outcome (outcomes) -> outcomes
      Context (context) -> bigPicture
      Stakeholders (stakeholders) -> stakeholderDescription
      Timing (timing) -> timing
      Resources and Budget (resources) -> constraints
      Trade-Offs (tradeOffs) -> objectives
      Working Relationship (relation) -> assumptions
    */
    let project={
      name: form.name,
      background: form.objectives,
      benefitsDescription: form.deliverables,
      outcomes: form.outcomes,
      bigPicture: form.context,
      stakeholderDescription: form.stakeholders,
      timing: form.timing,
      constraints: form.resources,
      objectives: form.tradeOffs,
      assumptions: form.relations
    }
    request
      .post("/projects/")
      .send(project)
      .then(function() {
        window.location="/";
      })
      .catch(function(error) {
        alert("Not able to add project: "+error);
      });
  }

  render() {
    return (
      <div style={{display:"flex", justifyContent:"center"}}>
        <div style={{maxWidth:1016,flexBasis:"100%"}}>
          {this.props.newForm ? (
            <AreaForm
              {...this.props}
              display="tab"
              item={{_progress:"relationship"}}
              selected={0}
              areas={translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)}
              onUpdate={this.submitProject.bind(this)}
              label="Project"
            />
          ) : (
            <form action="/projects/" method="POST">
              <GeneralInformation/>
              <BusinessObjective/>
              <DeliverableQualityAndScope/>
              <BusinessOutcome/>
              <Context/>
              <Stakeholders/>
              <Timing/>
              <ResourcesAndBudget/>
              <TradeOffs/>
              <WorkingRelationship/>
              <div style={{paddingTop: 30, paddingBottom:80, clear:"left", float:"none"}}>
                <input className="cancel" type="submit" name="cancel" value="Cancel"/>
                <input className="save" style={{marginLeft: 15}} type="submit" value="Save"/>
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
}

export default class NewExtremeProjectPage extends React.Component {
  render() {
    return (
      <Layout {...this.props}>
        <NewExtremeProject {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/NewExtremeProject.jsx